import { createContext, FC, PropsWithChildren, useMemo } from 'react'

import {
  FEATURE_FLAG_TYPE,
  HomepageServerSideFeatureFlags,
} from '@src/server-side/server-feature-flags/feature-flag.types'

export interface HomepageFeatureFlags {
  featureFlagType: typeof FEATURE_FLAG_TYPE.HOME
  isPersonalized: boolean
}

export const HomepageFeatureContext = createContext<HomepageFeatureFlags | null>(null)

interface HomeFeatureProviderProps {
  serverSideFeatureFlags: HomepageServerSideFeatureFlags | null | undefined
}

export const HomepageFeatureProvider: FC<PropsWithChildren<HomeFeatureProviderProps>> = ({
  children,
  serverSideFeatureFlags,
}) => {
  const featureFlags = useMemo(
    (): HomepageFeatureFlags => ({
      featureFlagType: FEATURE_FLAG_TYPE.HOME,
      isPersonalized: serverSideFeatureFlags?.isPersonalized ?? false,
    }),
    [serverSideFeatureFlags],
  )

  return <HomepageFeatureContext.Provider value={featureFlags}>{children}</HomepageFeatureContext.Provider>
}
